/**
 * 描述：护眼模式按钮
 * 日期：2017-9-6
 * 作者：Bai.Zhiming
 */
'use strict';
angular.module("eyeProtectionModelModule", [])
    .directive("eyePortectionModel", [function() {
        return {
            restrict: 'E',
            replace: true,
            scope: true,
            template: ['<a class="eyeProtectionModel">',
                '<p ng-mouseenter="status.showColor=true" ng-mouseleave="status.showColor=false" ng-if="status.showColor&&status.huyan" class="showColor">',
                '<span class="colorAqua" ng-click="changeEditBackcol(false,\'rgba(204, 232, 207,1)\')"></span><span class="colorGreen" ng-click="changeEditBackcol(false,\'#BFEFFF\')"></span><span class="colorPink" ng-click="changeEditBackcol(false,\'#8EE5EE\')"></span><span class="colorPurple" ng-click="changeEditBackcol(false,\'#98FB98\')"></span>',
                '</p>',
                '<i ng-click="openProtect()" ng-show="!status.huyan" class="iconfont icon-yincang1"><span>护眼模式</span></i>',
                '<i ng-click="stopProtect()" ng-mouseenter="status.showColor=true" ng-show="status.huyan" class="iconfont icon-xianshi"><span>护眼模式</span></i>',
                '</a>'
            ].join(""),
            link: function(scope, $elem, $attrs) {
                initStatus();
                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    scope.status = {
                        showColor: false,
                        huyan: false
                    };
                }
                /**
                 * [changeEditBackcol description] 改变编辑器背景色
                 * @param  {[type]} boolean [description]
                 * @param  {[type]} color   [description]
                 * @return {[type]}         [description]
                 */
                scope.changeEditBackcol = function(boolean, color) {
                    scope.status.showColor = false;
                    $("ueditorlocation iframe").contents().find("body").css("background", color);
                    // $(angular.element(document)).find('ueditorLocation iframe .view').css("background",color);
                };
                /**
                 * [openProtect description] 开启保护
                 * @return {[type]} [description]
                 */
                scope.openProtect = function() {
                    scope.status.huyan = true;
                };
                /**
                 * [stopProtect description] 停止保护
                 * @return {[type]} [description]
                 */
                scope.stopProtect = function() {
                    scope.status.huyan = false;
                    $("ueditorlocation iframe").contents().find("body").css("background", 'white');
                };
            }
        };
    }]);